import createSagaMiddleware from 'redux-saga';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import rootSaga from './sagas';
// Import all the reducer here
import paymentReducer from './payment/payment.slice';

const sagaMiddleware = createSagaMiddleware();

const middleware = [...getDefaultMiddleware(), sagaMiddleware];
const rootReducer = {
  payment: paymentReducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production'
});

store.sagaTask = sagaMiddleware.run(rootSaga);

export default store;
